
import { removeToken } from '@/utils/auth'
export default {
  name: 'Navbar',
  data() {
    return {
      avatar: 'https://api.baokuanxia.com/upload/head/avatar.png',
      searchValue: '',
    }
  },
  methods: {
    /**
     * 搜索触发回车键
     */
    handleEnter(e) {
      if (e.key === 'Enter' || e.keyCode === 13) {
        this.$bus.$emit('handleSearch', this.searchValue)
      }
    },
    /**
     * 退出登录
     */
    logout() {
      this.$confirm('确定注销登录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          removeToken(this)
          location.href = '/login'
        })
        .catch(() => { })
    },
  },
}
